import GraspingRules from './grasping_rules.vue';

export default GraspingRules;
